import React from 'react';
import { connect } from 'react-redux';
import { getProfile, getVendor } from '~/accounts/signup/selectors';
import { vendorUpdate } from '../actions';
import VendorUpdateView from '../components/UpdateVendorView';

const UpdateVendorContainer = props => <VendorUpdateView {...props} />;

const mapStateToProps = state => ({
  profile: getProfile(state),
  vendor: getVendor(state)
});

const mapDispatchToProps = dispatch => ({
  vendorUpdateAction: (...p) => dispatch(vendorUpdate(...p))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateVendorContainer);
